module.exports = __webpack_public_path__ + "0c89f9cbf40cddc5ef306715491ab6c0.MP3";